import { CheckMobileScreen, MobileActionNames } from './types';

export const checkIsMobileScreenAction = (isMobile: boolean): CheckMobileScreen => ({
  type: MobileActionNames.SCREEN_RESIZE,
  payload: isMobile
});
